import AppleIcon from 'assets/icons/landing/apple'
import GooglePlayIcon from 'assets/icons/landing/google-play'
import HuaweiIcon from 'assets/icons/landing/huawei'
import CubicImage from 'assets/images/landing/cubic-image.png'
import BodyText from 'components/UI/Landing/body-text'
import { useTranslation } from 'react-i18next'

const SuperappBanner = ({ className }: { className?: string }) => {
  const {
    t,
    i18n: { language }
  } = useTranslation('footer')

  return (
    <div className={`relative bg-[#ffffff] dark:bg-[#191919] rounded-xl p-5 md:p-6 ${className}`}>
      <div className='md:pl-[170px]'>
        <h5 className='text-main text-md mb-2 font-semibold'>{t('footer.app-ffin')}</h5>
        <BodyText
          className='text-xs leading-[18px] text-[#5C5C5C] dark:text-[#B7BBBD]'
          text={t('footer.app-ffin-note')}
        />
        <div className='mt-5'>
          <div className='flex items-center gap-x-3'>
            <a href={`https://bankffin.kz/${language}/res/mobile-app`} className='text-main text-sm block'>
              <GooglePlayIcon className='text-[#5C5C5C]' />
            </a>
            <a href={`https://bankffin.kz/${language}/res/mobile-app`} className='text-main text-sm block'>
              <AppleIcon className='text-[#5C5C5C]' />
            </a>
            <a href={`https://bankffin.kz/${language}/res/mobile-app`} className='text-main text-sm block'>
              <HuaweiIcon className='text-[#5C5C5C]' />
            </a>
          </div>
        </div>
      </div>
      <img
        src={CubicImage}
        width={160}
        height={160}
        alt='super app'
        className='absolute top-1/2 left-0 -translate-y-1/2 hidden md:block'
      />
    </div>
  )
}

export default SuperappBanner
